// Plaintext shape carried inside `Photo.encryptedMeta`. Cifrato sotto K_album,
// quindi il backend non vede nulla — solo i client che possiedono la chiave.
//
// Schema v1 (release ≤ 0.9.3): solo identificativi del file.
// Schema v2 (release 0.9.4+):  aggiunge `exif` con dati di scatto (data/GPS/
// dispositivo/esposizione). Il campo `v` è obbligatorio nei nuovi blob; i blob
// pre-0.9.4 non lo hanno e sono trattati come v=1 dal parser.
//
// I consumer attuali leggono solo filename/mimeType e ignorano il resto, quindi
// il bump è retro-compatibile in lettura. Il piano di backfill per i blob v=1
// è documentato in `.docs/exif-encrypted-metadata.md` (fase 0.9.6).
// Lenient parse: il payload è già stato decifrato sotto K_album, quindi
// l'integrità è garantita dal GCM tag. Questo parser non rifiuta input ma
// normalizza al meglio e restituisce `null` solo se il JSON è inutilizzabile.
export function parsePhotoMeta(json) {
    let raw;
    try {
        raw = JSON.parse(json);
    }
    catch {
        return null;
    }
    if (!raw || typeof raw !== 'object')
        return null;
    const r = raw;
    const filename = typeof r['filename'] === 'string' ? r['filename'] : '';
    const mimeType = typeof r['mimeType'] === 'string' ? r['mimeType'] : '';
    const size = typeof r['size'] === 'number' ? r['size'] : 0;
    if (r['v'] === 2) {
        const exif = r['exif'];
        return {
            v: 2,
            filename,
            mimeType,
            size,
            ...(exif && typeof exif === 'object' ? { exif: exif } : {}),
        };
    }
    return { v: 1, filename, mimeType, size };
}
//# sourceMappingURL=photoMeta.js.map